export default function ArrowLeftIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41406 13L13 16.5859L13 18L11.5859 18L5.58594 12L11.5859 6L13 6L13 7.41406L9.41406 11L18 11L18 13L9.41406 13Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
